import axios from "@configs/axios";
import { useMutation } from "@tanstack/react-query";

export const updateFideVerification = ({ data }) => {
  return axios.post(`/api/profile-fide/`, data);
};

export const useUpdateFideVerification = ({ config } = {}) => {
  return useMutation({
    // onSuccess: () => {
    //   queryClient.invalidateQueries("usersList");
    // },
    ...config,
    mutationFn: updateFideVerification,
  });
};
